import React, { createContext, useContext, useState, useEffect } from 'react';

// Translations for all languages
const translations = {
  sq: {
    // Header
    nav_home: "Ballina",
    nav_collection: "Koleksioni",
    nav_faq: "FAQ",
    nav_contact: "Kontakti",
    
    // Hero Section
    hero_premium: "Koleksion Premium",
    hero_title_1: "Elegancë",
    hero_title_2: "në Lëvizje",
    hero_subtitle: "Përjetoni luksozin e vërtetë me koleksionin tonë ekskluziv të automjeteve premium në Aeroportin e Tiranës",
    hero_cta: "Zbuloni Koleksionin",
    hero_contact: "Kontakt Direkt",
    
    // Features Section
    feature_new_cars: "Makina të Reja",
    feature_new_cars_desc: "Flota jonë përfshin vetëm makina moderne dhe të mirëmbajtura për rehati maksimale.",
    feature_support: "Mbështetje 24/7",
    feature_support_desc: "Ekipi ynë është i disponueshëm çdo ditë, çdo orë për t'ju ndihmuar me çdo nevojë.",
    feature_airport: "Marrje në Aeroport",
    feature_airport_desc: "Merrni makinën drejtpërdrejt në Aeroportin e Tiranës, shërbim pa stres.",
    feature_reasonable_prices: "Çmime të Arsyeshme",
    feature_reasonable_prices_desc: "Ofertat më konkurruese në treg për qiraje afatshkurtra dhe afatgjata.",
    
    // Collection Section
    collection_title: "Koleksioni Ekskluziv",
    collection_subtitle: "Përzgjidhet me kujdes për t'ju ofruar përvojën më të mirë të udhëtimit",
    our_collection: "Our Collection",
    filter_all: "Të gjitha",
    filter_price: "Çmimi",
    filter_fuel: "Karburanti",
    filter_transmission: "Transmetimi",
    filter_price_all: "Të gjitha çmimet",
    filter_price_budget: "Ekonomike (€0 - €100)",
    filter_price_premium: "Premium (€100 - €500)",
    filter_price_luxury: "Luksoze (€500+)",
    filter_fuel_all: "Të gjitha karburantet",
    filter_fuel_petrol: "Benzinë",
    filter_fuel_diesel: "Naftë",
    filter_fuel_electric: "Elektrike",
    filter_fuel_hybrid: "Hibride",
    filter_trans_all: "Të gjitha transmisionet",
    filter_trans_auto: "Automatik",
    filter_trans_manual: "Manual",
    clear_filters: "Pastro Filtrat",
    per_day: "/ditë",
    seats: "Ulëse",
    view_details: "Shiko",
    view_photo: "Shiko Foto",
    no_cars_found: "Asnjë makinë nuk u gjet me këto filtra.",
    loading_cars: "Duke ngarkuar makinat...",
    available_status: "Disponueshme",
    reserved_status: "Rezervuar",
    price_day: "Çmimi/Ditë",
    
    // Car Details
    car_details: "Detajet e Makinës",
    back: "Kthehu",
    back_to_home: "Kthehu në ballina",
    year: "Viti",
    fuel: "Karburanti",
    transmission: "Transmetimi",
    price_per_day: "Çmimi për ditë",
    book_now: "Rezervo Tani",
    car_not_found: "Makina nuk u gjet",
    description: "Përshkrimi",
    persons: "Persona",
    click_to_zoom: "Kliko për të zmadhuar",
    
    // Booking Form
    booking_title: "Rezervo Tani",
    select_dates: "Zgjidhni Datat",
    pickup_date: "Data e Marrjes",
    return_date: "Data e Kthimit",
    your_info: "Informacionet Tuaja",
    full_name: "Emri i Plotë",
    email: "Email",
    phone: "Telefon",
    message_optional: "Mesazh (Opsionale)",
    additional_notes: "Shënime shtesë...",
    num_days: "Numri i ditëve",
    total: "Totali",
    confirm_booking: "Konfirmo Rezervimin",
    dates_taken: "Datat e Zëna",
    
    // Time Selection
    pickup_time: "Ora e Marrjes",
    return_time: "Ora e Kthimit",
    select_time: "Zgjidhni orën",
    same_day_booking: "Rezervim brenda ditës",
    same_day_note: "Çmimi i plotë i ditës aplikohet edhe për rezervime brenda ditës",
    time_24_7: "Shërbim 24/7 - Marrje/Kthim çdo orë",
    
    // Booked Dates
    booked_dates: "Datat e Zëna",
    confirmed: "Konfirmuar",
    pending: "Në pritje",
    car_not_available: "Makina nuk është e disponueshme!",
    select_other_dates: "Ju lutem zgjidhni data të tjera.",
    dates_conflict: "Datat e zgjedhura përplasen me rezervimet ekzistuese:",
    checking_availability: "Duke kontrolluar disponueshmërinë...",
    view_bookings: "Shiko rezervimet ekzistuese",
    view_existing_bookings: "Shiko {count} rezervime ekzistuese",
    selected_dates: "Datat e zgjedhura:",
    pickup: "Marrja",
    return_label: "Kthimi",
    legend_confirmed: "E Zënë (Konfirmuar)",
    legend_pending: "Në Pritje",
    legend_selected: "Zgjedhja Juaj",
    
    // Document Upload
    documents_required: "Dokumentet e Kërkuara",
    upload_id: "Ngarko Dokumentin e Identitetit",
    upload_license: "Ngarko Patentën",
    id_document: "Dokument Identiteti (ID/Pasaportë)",
    license_document: "Patenta e Shoferit",
    upload_instructions: "Ngarko foto të qartë të dokumentit (JPG, PNG ose PDF, max 10MB)",
    document_uploaded: "Dokumenti u ngarkua me sukses",
    document_upload_error: "Gabim në ngarkimin e dokumentit",
    documents_required_error: "Ju lutem ngarkoni dokumentin e ID dhe Patentën",
    uploading: "Duke ngarkuar...",
    file_too_large: "Skedari është shumë i madh (max 10MB)",
    invalid_file_type: "Tipi i skedarit nuk lejohet (vetëm JPG, PNG, PDF)",
    view_gallery: "Shiko Galerinë",
    gallery: "Galeria",
    photo: "Foto",
    of: "nga",
    
    // Payment Options
    pay_at_airport: "Rezervo - Paguaj në Aeroport",
    pay_online: "Paguaj Online me Kartë",
    or: "ose",
    processing: "Duke procesuar...",
    secure_payment: "Pagesë e sigurt me Stripe",
    
    // Reviews
    reviews: "Vlerësimet",
    reviews_title: "Vlerësimet e Klientëve",

    // Period pricing
    period_prices_title: "Çmimet sipas periudhave",
    period_name: "Periudha",
    period_range: "Data",
    period_prices_note: "Sezoni Veror: 1 Qershor - 30 Shtator. Sezoni Dimëror: 1 Tetor - 30 Maj.",
    write_review: "Shkruaj Vlerësim",
    your_rating: "Vlerësimi juaj",
    your_review: "Komenti juaj",
    submit_review: "Dërgo Vlerësimin",
    review_success: "Faleminderit për vlerësimin tuaj!",
    review_error: "Gabim në dërgimin e vlerësimit",
    no_reviews: "Ende nuk ka vlerësime për këtë makinë",
    be_first_review: "Bëhu i pari që lë një vlerësim!",
    verified_customer: "Klient i Verifikuar",
    rating_required: "Ju lutem zgjidhni një vlerësim (1-5 yje)",
    stars: "yje",
    based_on: "bazuar në",
    reviews_count: "vlerësime",
    average_rating: "Vlerësimi mesatar",
    
    // Discounts
    discount: "Ulje",
    base_price: "Çmimi bazë",
    available_discounts: "Uljet e disponueshme:",
    
    // Booking Success & Errors
    booking_success: "Rezervimi u krye me sukses! Do t'ju kontaktojmë për konfirmim. Pagesa do të kryhet në aeroport.",
    booking_error: "Gabim në krijimin e rezervimit",
    select_dates_error: "Ju lutem zgjidhni datat e marrjes dhe kthimit",
    return_after_pickup: "Data e kthimit duhet të jetë pas datës së marrjes",
    return_time_after_pickup: "Ora e kthimit duhet të jetë pas orës së marrjes për rezervime brenda ditës",
    dates_not_available: "Makina nuk është e disponueshme për këto data. Ju lutem zgjidhni data të tjera.",
    fill_all_fields: "Ju lutem plotësoni të gjitha fushat e kërkuara",
    payment_error: "Gabim në krijimin e pagesës. Ju lutem provoni përsëri.",
    car_load_error: "Gabim në ngarkimin e detajeve të makinës",
    
    // FAQ Section
    faq_title: "Pyetje të Shpeshta",
    faq_subtitle: "Si mund t'ju ndihmojmë?",
    faq_q1: "Si funksionon procesi i qirasë?",
    faq_a1: "Zgjidhni makinën tuaj, plotësoni formën e rezervimit me datat e dëshiruara dhe të dhënat tuaja. Do t'ju kontaktojmë për konfirmim brenda pak orësh. Pagesa kryhet në aeroportin e Tiranës kur merrni makinën.",
    faq_q2: "Çfarë dokumentesh më duhen?",
    faq_a2: "Ju nevojitet një patentë shoferi e vlefshme, një dokument identiteti (ID ose pasaportë) dhe një kartë krediti/debiti për depozitën e sigurimit.",
    faq_q3: "A ka limit kilometrash?",
    faq_a3: "Jo, të gjitha qiratë tona vijnë me kilometra të pakufizuara. Mund të udhëtoni sa të dëshironi pa kosto shtesë.",
    faq_q4: "A është e përfshirë sigurimi?",
    faq_a4: "Po, të gjitha makinat vijnë me sigurim bazik. Ofrojmë edhe sigurim të plotë me mbulim të zgjeruar me kosto shtesë.",
    faq_q5: "A mund ta kthej makinën më herët?",
    faq_a5: "Po, ju mund ta ktheni makinën më herët, por çmimi mbetet i njëjtë sipas rezervimit tuaj origjinal. Nëse keni ndryshime, na kontaktoni më parë.",
    faq_q6: "A ofroni shërbim në aeroport 24/7?",
    faq_a6: "Po, ne jemi të pranishëm në Aeroportin Ndërkombëtar të Tiranës 24 orë në ditë, 7 ditë në javë për të ju shërbyer.",
    
    // Contact Section
    contact_title: "Na Kontaktoni",
    contact_subtitle: "Jemi këtu për t'ju ndihmuar 24/7",
    contact_get_in_touch: "Get In Touch",
    contact_address: "Adresa",
    contact_address_value: "Aeroporti Ndërkombëtar i Tiranës",
    contact_phone: "Telefon",
    contact_email: "Email",
    contact_hours: "Orari",
    contact_hours_value: "24/7 - Çdo ditë",
    contact_form_title: "Dërgoni Mesazh",
    contact_name: "Emri",
    contact_your_email: "Email",
    contact_your_phone: "Telefon",
    contact_your_message: "Mesazhi",
    send_message: "Dërgo Mesazhin",
    message_sent: "Mesazhi u dërgua me sukses! Do t'ju kontaktojmë së shpejti.",
    message_error: "Gabim në dërgimin e mesazhit",
    
    // Footer
    footer_rights: "Të gjitha të drejtat e rezervuara",
    footer_description: "Makina luksoze për qira në Aeroportin e Tiranës",
    
    // Common
    loading: "Duke ngarkuar...",
    error: "Gabim",
    success: "Sukses",
    not_available: "Jo e Disponueshme",
    available: "E Disponueshme",
    
    // Admin Panel
    admin_panel: "Admin Panel",
    admin_login: "Kyçu",
    admin_logging_in: "Duke u kyçur...",
    admin_username: "Username",
    admin_password: "Password",
    admin_enter_username: "Vendos username",
    admin_enter_password: "Vendos password",
    admin_login_success: "Login i suksesshëm!",
    admin_login_error: "Username ose password i gabuar",
    admin_back_home: "← Kthehu në faqen kryesore",
    admin_logout: "Çkyçu",
    admin_logout_success: "U çkyçët me sukses",
    
    // Admin Dashboard
    admin_dashboard: "Admin Dashboard",
    admin_stats: "Statistika",
    admin_bookings: "Rezervimet",
    admin_cars: "Makinat",
    admin_discounts: "Uljet",
    admin_messages: "Mesazhet",
    
    // Admin Stats
    admin_total_bookings: "Rezervime Totale",
    admin_revenue: "Të Ardhurat",
    admin_total_cars: "Makina Totale",
    admin_cars_available: "të disponueshme",
    admin_pending: "Në Pritje",
    admin_confirmed: "Të Konfirmuara",
    
    // Admin Bookings
    admin_car: "Makina",
    admin_client: "Klienti",
    admin_dates: "Datat",
    admin_price_payment: "Çmimi & Pagesa",
    admin_status: "Statusi",
    admin_discount_applied: "ulje",
    admin_paid: "Paguar",
    admin_deposit: "Kapar",
    admin_unpaid: "Pa Paguar",
    admin_remaining: "Mbetur",
    admin_status_confirmed: "Konfirmuar",
    admin_status_cancelled: "Anuluar",
    admin_status_pending: "Në Pritje",
    admin_confirm: "Konfirmo",
    admin_payment: "Pagesë",
    admin_cancel: "Anulo",
    admin_no_bookings: "Nuk ka rezervime",
    admin_status_updated: "Statusi u përditësua",
    admin_status_error: "Gabim në përditësimin e statusit",
    
    // Admin Cars
    admin_car_management: "Menaxhimi i Makinave",
    admin_add_car: "Shto Makinë",
    admin_edit_car: "Ndrysho Makinën",
    admin_add_new_car: "Shto Makinë të Re",
    admin_car_brand: "Marka",
    admin_car_model: "Modeli",
    admin_car_year: "Viti",
    admin_car_price: "Çmimi/Ditë (€)",
    admin_car_price_high_season: "Çmimi/Ditë (Fluks) (€)",
    admin_car_min_days: "Minimum ditë rezervimi",
    admin_high_season_note: "1 Qershor - 30 Shtator",

    // Insurance
    admin_insurance_prices: "Siguracionet (€/ditë)",
    insurance_tpl: "TPL",
    insurance_mini_kasko: "Mini Kasko",
    insurance_full_kasko: "Full Kasko",
    insurance_title: "Siguracion",
    insurance_note: "Siguracionet llogariten veç dhe nuk përfshihen në ulje.",
    admin_car_fuel: "Karburanti",
    admin_car_transmission: "Transmetimi",
    admin_car_seats: "Ulëse",
    admin_car_available: "E Disponueshme",
    admin_car_image: "URL e Fotos",
    admin_car_description: "Përshkrimi",
    admin_car_reserved: "E Rezervuar",
    admin_car_free: "E Lirë",
    admin_active_bookings: "Rezervime Aktive",
    admin_edit: "Ndrysho",
    admin_save: "Ruaj",
    admin_cancel_action: "Anulo",
    admin_delete_car_confirm: "A jeni i sigurt që dëshironi të fshini këtë makinë?",
    admin_car_updated: "Makina u përditësua",
    admin_car_added: "Makina u shtua",
    admin_car_deleted: "Makina u fshi",
    admin_car_save_error: "Gabim në ruajtjen e makinës",
    admin_car_delete_error: "Gabim në fshirjen e makinës",
    admin_yes: "Po",
    admin_no: "Jo",
    
    // Admin Discounts
    admin_discounts_title: "Uljet sipas Ditëve",
    admin_discounts_subtitle: "Klientët përfitojnë ulje automatike kur rezervojnë për më shumë ditë",
    admin_add_discount: "Shto Ulje",
    admin_add_new_discount: "Shto Ulje të Re",
    admin_min_days: "Ditë Minimale",
    admin_discount_percent: "Përqindja e Uljes (%)",
    admin_discount_description: "Përshkrimi",
    admin_discount_added: "Ulja u shtua",

    // Car-specific discounts
    admin_car_discounts_title: "Ulje sipas makinës",
    admin_car_discounts_subtitle: "Zgjidh një makinë dhe vendos range tiers (min–max ditë) + ulje €/ditë.",
    admin_select_car: "Zgjidh makinën",
    admin_min_days: "Min ditë",
    admin_max_days: "Max ditë (opsionale)",
    admin_discount_per_day: "Ulje €/ditë",
    admin_no_car_discounts: "Nuk ka ulje për këtë makinë.",
    admin_car_discount_overlap_note: "Nëse range-t mbivendosen, merret tier me min_days më të madh (p.sh. 3–5 fiton ndaj 1–3 për ditën 3).",
    admin_discount_deleted: "Ulja u fshi",
    admin_discount_failed: "Gabim në ulje",
    admin_discount_save_error: "Gabim në ruajtjen e uljes",
    admin_discount_delete_error: "Gabim në fshirjen e uljes",
    admin_days_plus: "+ ditë",
    
    // Admin Messages
    admin_messages_title: "Mesazhet nga Klientët",
    admin_messages_subtitle: "Mesazhe të dërguara përmes formularit të kontaktit",
    admin_messages_count: "mesazhe",
    admin_no_messages: "Nuk ka mesazhe ende",
    admin_messages_appear: "Mesazhet e reja do të shfaqen këtu",
    admin_reply: "Përgjigju",
    admin_delete_message_confirm: "A jeni i sigurt që dëshironi të fshini këtë mesazh?",
    admin_message_deleted: "Mesazhi u fshi",
    admin_message_delete_error: "Gabim në fshirjen e mesazhit",
    
    // Admin Payment
    admin_manage_payment: "Menaxho Pagesën",
    admin_client_label: "Klienti",
    admin_total_label: "Totali",
    admin_paid_so_far: "Paguar deri tani",
    admin_deposit_advance: "Kapar (Paradhënie)",
    admin_deposit_amount: "Shuma e kaparit",
    admin_register_deposit: "Regjistro Kapar",
    admin_mark_fully_paid: "Shëno si të Paguar Plotësisht",
    admin_remove_payment: "Hiq Pagesën",
    admin_paid_fully: "Shënuar si i paguar plotësisht!",
    admin_deposit_registered: "Kapar u regjistrua!",
    admin_payment_removed: "Pagesa u hoq",
    admin_payment_error: "Gabim në përditësimin e pagesës",

    // Admin Booking Price Edit / Delete
    admin_edit_total: "Ndrysho Totalin",
    admin_total_updated: "Totali u përditësua",
    admin_total_update_error: "Gabim në përditësimin e totalit",
    admin_total_invalid: "Totali duhet të jetë më i madh se 0",
    admin_delete_booking: "Fshi Rezervimin",
    admin_delete_booking_confirm: "A jeni i sigurt që dëshironi ta fshini këtë rezervim?",
    admin_booking_deleted: "Rezervimi u fshi",
    admin_booking_delete_error: "Gabim në fshirjen e rezervimit",
    admin_total_pending_note: "Lejohet vetëm kur rezervimi është në pritje (pending).",

    // Min rental days
    min_days_error: "Kjo makinë kërkon minimumi",
    days: "ditë",
  },
  
  en: {
    // Header
    nav_home: "Home",
    nav_collection: "Collection",
    nav_faq: "FAQ",
    nav_contact: "Contact",
    
    // Hero Section
    hero_premium: "Premium Collection",
    hero_title_1: "Elegance",
    hero_title_2: "in Motion",
    hero_subtitle: "Experience true luxury with our exclusive collection of premium vehicles at Tirana Airport",
    hero_cta: "Discover Collection",
    hero_contact: "Direct Contact",
    
    // Features Section
    feature_new_cars: "New Cars",
    feature_new_cars_desc: "Our fleet includes only modern and well-maintained cars for maximum comfort.",
    feature_support: "24/7 Support",
    feature_support_desc: "Our team is available every day, every hour to assist you with any need.",
    feature_airport: "Airport Pickup",
    feature_airport_desc: "Pick up your car directly at Tirana Airport, stress-free service.",
    feature_reasonable_prices: "Reasonable Prices",
    feature_reasonable_prices_desc: "The most competitive offers on the market for short and long-term rentals.",
    
    // Collection Section
    collection_title: "Exclusive Collection",
    collection_subtitle: "Carefully selected to offer you the best travel experience",
    our_collection: "Our Collection",
    filter_all: "All",
    filter_price: "Price",
    filter_fuel: "Fuel",
    filter_transmission: "Transmission",
    filter_price_all: "All prices",
    filter_price_budget: "Budget (€0 - €100)",
    filter_price_premium: "Premium (€100 - €500)",
    filter_price_luxury: "Luxury (€500+)",
    filter_fuel_all: "All fuels",
    filter_fuel_petrol: "Petrol",
    filter_fuel_diesel: "Diesel",
    filter_fuel_electric: "Electric",
    filter_fuel_hybrid: "Hybrid",
    filter_trans_all: "All transmissions",
    filter_trans_auto: "Automatic",
    filter_trans_manual: "Manual",
    clear_filters: "Clear Filters",
    per_day: "/day",
    seats: "Seats",
    view_details: "View",
    view_photo: "View Photo",
    no_cars_found: "No cars found with these filters.",
    loading_cars: "Loading cars...",
    available_status: "Available",
    reserved_status: "Reserved",
    price_day: "Price/Day",
    
    // Car Details
    car_details: "Car Details",
    back: "Back",
    back_to_home: "Back to home",
    year: "Year",
    fuel: "Fuel",
    transmission: "Transmission",
    price_per_day: "Price per day",
    book_now: "Book Now",
    car_not_found: "Car not found",
    description: "Description",
    persons: "Persons",
    click_to_zoom: "Click to zoom",
    
    // Booking Form
    booking_title: "Book Now",
    select_dates: "Select Dates",
    pickup_date: "Pickup Date",
    return_date: "Return Date",
    your_info: "Your Information",
    full_name: "Full Name",
    email: "Email",
    phone: "Phone",
    message_optional: "Message (Optional)",
    additional_notes: "Additional notes...",
    num_days: "Number of days",
    total: "Total",
    confirm_booking: "Confirm Booking",
    dates_taken: "Dates Taken",
    
    // Time Selection
    pickup_time: "Pickup Time",
    return_time: "Return Time",
    select_time: "Select time",
    same_day_booking: "Same-day booking",
    same_day_note: "Full day price applies even for same-day bookings",
    time_24_7: "24/7 Service - Pickup/Return any time",
    
    // Booked Dates
    booked_dates: "Booked Dates",
    confirmed: "Confirmed",
    pending: "Pending",
    car_not_available: "Car is not available!",
    select_other_dates: "Please select other dates.",
    dates_conflict: "Selected dates conflict with existing bookings:",
    checking_availability: "Checking availability...",
    view_bookings: "View existing bookings",
    view_existing_bookings: "View {count} existing bookings",
    selected_dates: "Selected dates:",
    pickup: "Pickup",
    return_label: "Return",
    legend_confirmed: "Booked (Confirmed)",
    legend_pending: "Pending",
    legend_selected: "Your Selection",
    
    // Document Upload
    documents_required: "Required Documents",
    upload_id: "Upload ID Document",
    upload_license: "Upload Driver's License",
    id_document: "ID Document (ID/Passport)",
    license_document: "Driver's License",
    upload_instructions: "Upload a clear photo of the document (JPG, PNG or PDF, max 10MB)",
    document_uploaded: "Document uploaded successfully",
    document_upload_error: "Error uploading document",
    documents_required_error: "Please upload your ID and Driver's License",
    uploading: "Uploading...",
    file_too_large: "File is too large (max 10MB)",
    invalid_file_type: "File type not allowed (only JPG, PNG, PDF)",
    view_gallery: "View Gallery",
    gallery: "Gallery",
    photo: "Photo",
    of: "of",
    
    // Payment Options
    pay_at_airport: "Book - Pay at Airport",
    pay_online: "Pay Online with Card",
    or: "or",
    processing: "Processing...",
    secure_payment: "Secure payment with Stripe",
    
    // Reviews
    reviews: "Reviews",
    reviews_title: "Customer Reviews",

    // Period pricing
    period_prices_title: "Prices by period",
    period_name: "Period",
    period_range: "Dates",
    period_prices_note: "Summer season: Jun 1 - Sep 30. Winter season: Oct 1 - May 30.",
    write_review: "Write a Review",
    your_rating: "Your rating",
    your_review: "Your review",
    submit_review: "Submit Review",
    review_success: "Thank you for your review!",
    review_error: "Error submitting review",
    no_reviews: "No reviews yet for this car",
    be_first_review: "Be the first to leave a review!",
    verified_customer: "Verified Customer",
    rating_required: "Please select a rating (1-5 stars)",
    stars: "stars",
    based_on: "based on",
    reviews_count: "reviews",
    average_rating: "Average rating",
    
    // Discounts
    discount: "Discount",
    base_price: "Base price",
    available_discounts: "Available discounts:",
    
    // Booking Success & Errors
    booking_success: "Booking successful! We will contact you for confirmation. Payment will be made at the airport.",
    booking_error: "Error creating booking",
    select_dates_error: "Please select pickup and return dates",
    return_after_pickup: "Return date must be after pickup date",
    return_time_after_pickup: "Return time must be after pickup time for same-day bookings",
    dates_not_available: "Car is not available for these dates. Please select other dates.",
    fill_all_fields: "Please fill in all required fields",
    payment_error: "Error creating payment. Please try again.",
    car_load_error: "Error loading car details",
    
    // FAQ Section
    faq_title: "Frequently Asked Questions",
    faq_subtitle: "How can we help you?",
    faq_q1: "How does the rental process work?",
    faq_a1: "Choose your car, fill out the booking form with your desired dates and details. We will contact you for confirmation within a few hours. Payment is made at Tirana Airport when you pick up the car.",
    faq_q2: "What documents do I need?",
    faq_a2: "You need a valid driver's license, an ID document (ID or passport), and a credit/debit card for the security deposit.",
    faq_q3: "Is there a mileage limit?",
    faq_a3: "No, all our rentals come with unlimited mileage. You can travel as much as you want at no extra cost.",
    faq_q4: "Is insurance included?",
    faq_a4: "Yes, all cars come with basic insurance. We also offer comprehensive insurance with extended coverage for an additional cost.",
    faq_q5: "Can I return the car earlier?",
    faq_a5: "Yes, you can return the car earlier, but the price remains the same as per your original booking. If you have changes, please contact us in advance.",
    faq_q6: "Do you offer 24/7 airport service?",
    faq_a6: "Yes, we are present at Tirana International Airport 24 hours a day, 7 days a week to serve you.",
    
    // Contact Section
    contact_title: "Contact Us",
    contact_subtitle: "We're here to help you 24/7",
    contact_get_in_touch: "Get In Touch",
    contact_address: "Address",
    contact_address_value: "Tirana International Airport",
    contact_phone: "Phone",
    contact_email: "Email",
    contact_hours: "Hours",
    contact_hours_value: "24/7 - Every day",
    contact_form_title: "Send a Message",
    contact_name: "Name",
    contact_your_email: "Email",
    contact_your_phone: "Phone",
    contact_your_message: "Message",
    send_message: "Send Message",
    message_sent: "Message sent successfully! We will contact you soon.",
    message_error: "Error sending message",
    
    // Footer
    footer_rights: "All rights reserved",
    footer_description: "Luxury car rental at Tirana Airport",
    
    // Common
    loading: "Loading...",
    error: "Error",
    success: "Success",
    not_available: "Not Available",
    available: "Available",
    
    // Admin Panel
    admin_panel: "Admin Panel",
    admin_login: "Login",
    admin_logging_in: "Logging in...",
    admin_username: "Username",
    admin_password: "Password",
    admin_enter_username: "Enter username",
    admin_enter_password: "Enter password",
    admin_login_success: "Login successful!",
    admin_login_error: "Invalid username or password",
    admin_back_home: "← Back to homepage",
    admin_logout: "Logout",
    admin_logout_success: "Logged out successfully",
    
    // Admin Dashboard
    admin_dashboard: "Admin Dashboard",
    admin_stats: "Statistics",
    admin_bookings: "Bookings",
    admin_cars: "Cars",
    admin_discounts: "Discounts",
    admin_messages: "Messages",
    
    // Admin Stats
    admin_total_bookings: "Total Bookings",
    admin_revenue: "Revenue",
    admin_total_cars: "Total Cars",
    admin_cars_available: "available",
    admin_pending: "Pending",
    admin_confirmed: "Confirmed",
    
    // Admin Bookings
    admin_car: "Car",
    admin_client: "Client",
    admin_dates: "Dates",
    admin_price_payment: "Price & Payment",
    admin_status: "Status",
    admin_discount_applied: "discount",
    admin_paid: "Paid",
    admin_deposit: "Deposit",
    admin_unpaid: "Unpaid",
    admin_remaining: "Remaining",
    admin_status_confirmed: "Confirmed",
    admin_status_cancelled: "Cancelled",
    admin_status_pending: "Pending",
    admin_confirm: "Confirm",
    admin_payment: "Payment",
    admin_cancel: "Cancel",
    admin_no_bookings: "No bookings",
    admin_status_updated: "Status updated",
    admin_status_error: "Error updating status",
    
    // Admin Cars
    admin_car_management: "Car Management",
    admin_add_car: "Add Car",
    admin_edit_car: "Edit Car",
    admin_add_new_car: "Add New Car",
    admin_car_brand: "Brand",
    admin_car_model: "Model",
    admin_car_year: "Year",
    admin_car_price: "Price/Day (€)",
    admin_car_price_high_season: "Price/Day (High Season) (€)",
    admin_car_min_days: "Minimum rental days",
    admin_high_season_note: "Jun 1 - Sep 30",

    // Insurance
    admin_insurance_prices: "Insurance (€/day)",
    insurance_tpl: "TPL",
    insurance_mini_kasko: "Mini Kasko",
    insurance_full_kasko: "Full Kasko",
    admin_car_fuel: "Fuel",
    insurance_title: "Insurance",
    insurance_note: "Insurance is calculated separately and not discounted.",

    admin_car_transmission: "Transmission",
    admin_car_seats: "Seats",
    admin_car_available: "Available",
    admin_car_image: "Photo URL",
    admin_car_description: "Description",
    admin_car_reserved: "Reserved",
    admin_car_free: "Free",
    admin_active_bookings: "Active Bookings",
    admin_edit: "Edit",
    admin_save: "Save",
    admin_cancel_action: "Cancel",
    admin_delete_car_confirm: "Are you sure you want to delete this car?",
    admin_car_updated: "Car updated",
    admin_car_added: "Car added",
    admin_car_deleted: "Car deleted",
    admin_car_save_error: "Error saving car",
    admin_car_delete_error: "Error deleting car",
    admin_yes: "Yes",
    admin_no: "No",
    
    // Admin Discounts
    admin_discounts_title: "Discounts by Days",
    admin_discounts_subtitle: "Customers get automatic discounts when booking for more days",
    admin_add_discount: "Add Discount",
    admin_add_new_discount: "Add New Discount",
    admin_min_days: "Minimum Days",
    admin_discount_percent: "Discount Percentage (%)",
    admin_discount_description: "Description",
    admin_discount_added: "Discount added",

    // Car-specific discounts
    admin_car_discounts_title: "Car discounts",
    admin_car_discounts_subtitle: "Select a car and add range tiers (min–max days) + discount €/day.",
    admin_select_car: "Select car",
    admin_min_days: "Min days",
    admin_max_days: "Max days (optional)",
    admin_discount_per_day: "Discount €/day",
    admin_no_car_discounts: "No discounts for this car.",
    admin_car_discount_overlap_note: "If ranges overlap, the tier with higher min_days wins (e.g. 3–5 beats 1–3 for day 3).",
    admin_discount_deleted: "Discount deleted",
    admin_discount_failed: "Discount error",
    admin_discount_save_error: "Error saving discount",
    admin_discount_delete_error: "Error deleting discount",
    admin_days_plus: "+ days",
    
    // Admin Messages
    admin_messages_title: "Customer Messages",
    admin_messages_subtitle: "Messages sent through the contact form",
    admin_messages_count: "messages",
    admin_no_messages: "No messages yet",
    admin_messages_appear: "New messages will appear here",
    admin_reply: "Reply",
    admin_delete_message_confirm: "Are you sure you want to delete this message?",
    admin_message_deleted: "Message deleted",
    admin_message_delete_error: "Error deleting message",
    
    // Admin Payment
    admin_manage_payment: "Manage Payment",
    admin_client_label: "Client",
    admin_total_label: "Total",
    admin_paid_so_far: "Paid so far",
    admin_deposit_advance: "Deposit (Advance)",
    admin_deposit_amount: "Deposit amount",
    admin_register_deposit: "Register Deposit",
    admin_mark_fully_paid: "Mark as Fully Paid",
    admin_remove_payment: "Remove Payment",
    admin_paid_fully: "Marked as fully paid!",
    admin_deposit_registered: "Deposit registered!",
    admin_payment_removed: "Payment removed",
    admin_payment_error: "Error updating payment",

    // Admin Booking Price Edit / Delete
    admin_edit_total: "Edit Total",
    admin_total_updated: "Total updated",
    admin_total_update_error: "Error updating total",
    admin_total_invalid: "Total must be greater than 0",
    admin_delete_booking: "Delete Booking",
    admin_delete_booking_confirm: "Are you sure you want to delete this booking?",
    admin_booking_deleted: "Booking deleted",
    admin_booking_delete_error: "Error deleting booking",
    admin_total_pending_note: "Only allowed when booking is pending.",

    // Min rental days
    min_days_error: "This car requires minimum",
    days: "days",
  },
  
  it: {
    // Header
    nav_home: "Home",
    nav_collection: "Collezione",
    nav_faq: "FAQ",
    nav_contact: "Contatti",
    
    // Hero Section
    hero_premium: "Collezione Premium",
    hero_title_1: "Eleganza",
    hero_title_2: "in Movimento",
    hero_subtitle: "Vivi il vero lusso con la nostra esclusiva collezione di veicoli premium all'Aeroporto di Tirana",
    hero_cta: "Scopri la Collezione",
    hero_contact: "Contatto Diretto",
    
    // Features Section
    feature_new_cars: "Auto Nuove",
    feature_new_cars_desc: "La nostra flotta comprende solo auto moderne e ben mantenute per il massimo comfort.",
    feature_support: "Supporto 24/7",
    feature_support_desc: "Il nostro team è disponibile ogni giorno, ogni ora per assisterti con ogni esigenza.",
    feature_airport: "Ritiro in Aeroporto",
    feature_airport_desc: "Ritira la tua auto direttamente all'Aeroporto di Tirana, servizio senza stress.",
    feature_reasonable_prices: "Prezzi Ragionevoli",
    feature_reasonable_prices_desc: "Le offerte più competitive sul mercato per noleggi a breve e lungo termine.",
    
    // Collection Section
    collection_title: "Collezione Esclusiva",
    collection_subtitle: "Selezionata con cura per offrirti la migliore esperienza di viaggio",
    our_collection: "La Nostra Collezione",
    filter_all: "Tutti",
    filter_price: "Prezzo",
    filter_fuel: "Carburante",
    filter_transmission: "Trasmissione",
    filter_price_all: "Tutti i prezzi",
    filter_price_budget: "Economica (€0 - €100)",
    filter_price_premium: "Premium (€100 - €500)",
    filter_price_luxury: "Lusso (€500+)",
    filter_fuel_all: "Tutti i carburanti",
    filter_fuel_petrol: "Benzina",
    filter_fuel_diesel: "Diesel",
    filter_fuel_electric: "Elettrica",
    filter_fuel_hybrid: "Ibrida",
    filter_trans_all: "Tutte le trasmissioni",
    filter_trans_auto: "Automatico",
    filter_trans_manual: "Manuale",
    clear_filters: "Cancella Filtri",
    per_day: "/giorno",
    seats: "Posti",
    view_details: "Vedi",
    view_photo: "Vedi Foto",
    no_cars_found: "Nessuna auto trovata con questi filtri.",
    loading_cars: "Caricamento auto...",
    available_status: "Disponibile",
    reserved_status: "Prenotata",
    price_day: "Prezzo/Giorno",
    
    // Car Details
    car_details: "Dettagli Auto",
    back: "Indietro",
    back_to_home: "Torna alla home",
    year: "Anno",
    fuel: "Carburante",
    transmission: "Trasmissione",
    price_per_day: "Prezzo al giorno",
    book_now: "Prenota Ora",
    car_not_found: "Auto non trovata",
    description: "Descrizione",
    persons: "Persone",
    click_to_zoom: "Clicca per ingrandire",
    
    // Booking Form
    booking_title: "Prenota Ora",
    select_dates: "Seleziona Date",
    pickup_date: "Data Ritiro",
    return_date: "Data Riconsegna",
    your_info: "Le Tue Informazioni",
    full_name: "Nome Completo",
    email: "Email",
    phone: "Telefono",
    message_optional: "Messaggio (Opzionale)",
    additional_notes: "Note aggiuntive...",
    num_days: "Numero di giorni",
    total: "Totale",
    confirm_booking: "Conferma Prenotazione",
    dates_taken: "Date Occupate",
    
    // Time Selection
    pickup_time: "Ora di Ritiro",
    return_time: "Ora di Riconsegna",
    select_time: "Seleziona ora",
    same_day_booking: "Prenotazione giornaliera",
    same_day_note: "Il prezzo giornaliero completo si applica anche per prenotazioni dello stesso giorno",
    time_24_7: "Servizio 24/7 - Ritiro/Riconsegna a qualsiasi ora",
    
    // Booked Dates
    booked_dates: "Date Prenotate",
    confirmed: "Confermato",
    pending: "In attesa",
    car_not_available: "Auto non disponibile!",
    select_other_dates: "Per favore seleziona altre date.",
    dates_conflict: "Le date selezionate sono in conflitto con prenotazioni esistenti:",
    checking_availability: "Verifica disponibilità...",
    view_bookings: "Vedi prenotazioni esistenti",
    view_existing_bookings: "Vedi {count} prenotazioni esistenti",
    selected_dates: "Date selezionate:",
    pickup: "Ritiro",
    return_label: "Riconsegna",
    legend_confirmed: "Prenotato (Confermato)",
    legend_pending: "In Attesa",
    legend_selected: "La Tua Selezione",
    
    // Document Upload
    documents_required: "Documenti Richiesti",
    upload_id: "Carica Documento d'Identità",
    upload_license: "Carica Patente di Guida",
    id_document: "Documento d'Identità (ID/Passaporto)",
    license_document: "Patente di Guida",
    upload_instructions: "Carica una foto chiara del documento (JPG, PNG o PDF, max 10MB)",
    document_uploaded: "Documento caricato con successo",
    document_upload_error: "Errore nel caricamento del documento",
    documents_required_error: "Per favore carica il tuo ID e la Patente di Guida",
    uploading: "Caricamento...",
    file_too_large: "File troppo grande (max 10MB)",
    invalid_file_type: "Tipo di file non consentito (solo JPG, PNG, PDF)",
    view_gallery: "Vedi Galleria",
    gallery: "Galleria",
    photo: "Foto",
    of: "di",
    
    // Payment Options
    pay_at_airport: "Prenota - Paga in Aeroporto",
    pay_online: "Paga Online con Carta",
    or: "oppure",
    processing: "Elaborazione...",
    secure_payment: "Pagamento sicuro con Stripe",
    
    // Reviews
    reviews: "Recensioni",
    reviews_title: "Recensioni dei Clienti",

    // Period pricing
    period_prices_title: "Prezzi per periodo",
    period_name: "Periodo",
    period_range: "Date",
    period_prices_note: "Stagione estiva: 1 Giugno - 30 Settembre. Stagione invernale: 1 Ottobre - 30 Maggio.",
    write_review: "Scrivi una Recensione",
    your_rating: "La tua valutazione",
    your_review: "La tua recensione",
    submit_review: "Invia Recensione",
    review_success: "Grazie per la tua recensione!",
    review_error: "Errore nell'invio della recensione",
    no_reviews: "Ancora nessuna recensione per questa auto",
    be_first_review: "Sii il primo a lasciare una recensione!",
    verified_customer: "Cliente Verificato",
    rating_required: "Per favore seleziona una valutazione (1-5 stelle)",
    stars: "stelle",
    based_on: "basato su",
    reviews_count: "recensioni",
    average_rating: "Valutazione media",
    
    // Discounts
    discount: "Sconto",
    base_price: "Prezzo base",
    available_discounts: "Sconti disponibili:",
    
    // Booking Success & Errors
    booking_success: "Prenotazione effettuata! Ti contatteremo per conferma. Il pagamento sarà effettuato in aeroporto.",
    booking_error: "Errore nella creazione della prenotazione",
    select_dates_error: "Per favore seleziona le date di ritiro e riconsegna",
    return_after_pickup: "La data di riconsegna deve essere successiva alla data di ritiro",
    return_time_after_pickup: "L'ora di riconsegna deve essere successiva all'ora di ritiro per prenotazioni dello stesso giorno",
    dates_not_available: "Auto non disponibile per queste date. Per favore seleziona altre date.",
    fill_all_fields: "Per favore compila tutti i campi richiesti",
    payment_error: "Errore nella creazione del pagamento. Riprova.",
    car_load_error: "Errore nel caricamento dei dettagli dell'auto",
    
    // FAQ Section
    faq_title: "Domande Frequenti",
    faq_subtitle: "Come possiamo aiutarti?",
    faq_q1: "Come funziona il processo di noleggio?",
    faq_a1: "Scegli la tua auto, compila il modulo di prenotazione con le date desiderate e i tuoi dati. Ti contatteremo per conferma entro poche ore. Il pagamento viene effettuato all'Aeroporto di Tirana al ritiro dell'auto.",
    faq_q2: "Quali documenti mi servono?",
    faq_a2: "Hai bisogno di una patente di guida valida, un documento d'identità (ID o passaporto) e una carta di credito/debito per il deposito cauzionale.",
    faq_q3: "C'è un limite di chilometraggio?",
    faq_a3: "No, tutti i nostri noleggi includono chilometraggio illimitato. Puoi viaggiare quanto vuoi senza costi aggiuntivi.",
    faq_q4: "L'assicurazione è inclusa?",
    faq_a4: "Sì, tutte le auto includono l'assicurazione base. Offriamo anche un'assicurazione completa con copertura estesa a un costo aggiuntivo.",
    faq_q5: "Posso restituire l'auto prima?",
    faq_a5: "Sì, puoi restituire l'auto prima, ma il prezzo rimane lo stesso della prenotazione originale. Se hai modifiche, contattaci in anticipo.",
    faq_q6: "Offrite servizio aeroportuale 24/7?",
    faq_a6: "Sì, siamo presenti all'Aeroporto Internazionale di Tirana 24 ore al giorno, 7 giorni alla settimana per servirti.",
    
    // Contact Section
    contact_title: "Contattaci",
    contact_subtitle: "Siamo qui per aiutarti 24/7",
    contact_get_in_touch: "Mettiti in Contatto",
    contact_address: "Indirizzo",
    contact_address_value: "Aeroporto Internazionale di Tirana",
    contact_phone: "Telefono",
    contact_email: "Email",
    contact_hours: "Orario",
    contact_hours_value: "24/7 - Ogni giorno",
    contact_form_title: "Invia un Messaggio",
    contact_name: "Nome",
    contact_your_email: "Email",
    contact_your_phone: "Telefono",
    contact_your_message: "Messaggio",
    send_message: "Invia Messaggio",
    message_sent: "Messaggio inviato con successo! Ti contatteremo presto.",
    message_error: "Errore nell'invio del messaggio",
    
    // Footer
    footer_rights: "Tutti i diritti riservati",
    footer_description: "Noleggio auto di lusso all'Aeroporto di Tirana",
    
    // Common
    loading: "Caricamento...",
    error: "Errore",
    success: "Successo",
    not_available: "Non Disponibile",
    available: "Disponibile",
    
    // Admin Panel
    admin_panel: "Pannello Admin",
    admin_login: "Accedi",
    admin_logging_in: "Accesso in corso...",
    admin_username: "Username",
    admin_password: "Password",
    admin_enter_username: "Inserisci username",
    admin_enter_password: "Inserisci password",
    admin_login_success: "Accesso riuscito!",
    admin_login_error: "Username o password non validi",
    admin_back_home: "← Torna alla homepage",
    admin_logout: "Esci",
    admin_logout_success: "Disconnessione riuscita",
    
    // Admin Dashboard
    admin_dashboard: "Dashboard Admin",
    admin_stats: "Statistiche",
    admin_bookings: "Prenotazioni",
    admin_cars: "Auto",
    admin_discounts: "Sconti",
    admin_messages: "Messaggi",
    
    // Admin Stats
    admin_total_bookings: "Prenotazioni Totali",
    admin_revenue: "Ricavi",
    admin_total_cars: "Auto Totali",
    admin_cars_available: "disponibili",
    admin_pending: "In Attesa",
    admin_confirmed: "Confermate",
    
    // Admin Bookings
    admin_car: "Auto",
    admin_client: "Cliente",
    admin_dates: "Date",
    admin_price_payment: "Prezzo & Pagamento",
    admin_status: "Stato",
    admin_discount_applied: "sconto",
    admin_paid: "Pagato",
    admin_deposit: "Caparra",
    admin_unpaid: "Non Pagato",
    admin_remaining: "Rimanente",
    admin_status_confirmed: "Confermato",
    admin_status_cancelled: "Cancellato",
    admin_status_pending: "In Attesa",
    admin_confirm: "Conferma",
    admin_payment: "Pagamento",
    admin_cancel: "Cancella",
    admin_no_bookings: "Nessuna prenotazione",
    admin_status_updated: "Stato aggiornato",
    admin_status_error: "Errore nell'aggiornamento dello stato",
    
    // Admin Cars
    admin_car_management: "Gestione Auto",
    admin_add_car: "Aggiungi Auto",
    admin_edit_car: "Modifica Auto",
    admin_add_new_car: "Aggiungi Nuova Auto",
    admin_car_brand: "Marca",
    admin_car_model: "Modello",
    admin_car_year: "Anno",
    admin_car_price: "Prezzo/Giorno (€)",
    admin_car_price_high_season: "Prezzo/Giorno (Alta Stagione) (€)",
    admin_car_min_days: "Giorni minimi di noleggio",
    admin_high_season_note: "1 Giugno - 30 Settembre",

    // Insurance
    admin_insurance_prices: "Assicurazione (€/giorno)",
    insurance_tpl: "TPL",
    insurance_title: "Assicurazione",
    insurance_note: "L'assicurazione è calcolata separatamente e non è scontata.",

    insurance_mini_kasko: "Mini Kasko",
    insurance_full_kasko: "Full Kasko",
    admin_car_fuel: "Carburante",
    admin_car_transmission: "Trasmissione",
    admin_car_seats: "Posti",
    admin_car_available: "Disponibile",
    admin_car_image: "URL Foto",
    admin_car_description: "Descrizione",
    admin_car_reserved: "Prenotata",
    admin_car_free: "Libera",
    admin_active_bookings: "Prenotazioni Attive",
    admin_edit: "Modifica",
    admin_save: "Salva",
    admin_cancel_action: "Annulla",
    admin_delete_car_confirm: "Sei sicuro di voler eliminare questa auto?",
    admin_car_updated: "Auto aggiornata",
    admin_car_added: "Auto aggiunta",
    admin_car_deleted: "Auto eliminata",
    admin_car_save_error: "Errore nel salvare l'auto",
    admin_car_delete_error: "Errore nell'eliminare l'auto",
    admin_yes: "Sì",
    admin_no: "No",
    
    // Admin Discounts
    admin_discounts_title: "Sconti per Giorni",
    admin_discounts_subtitle: "I clienti ottengono sconti automatici quando prenotano per più giorni",
    admin_add_discount: "Aggiungi Sconto",
    admin_add_new_discount: "Aggiungi Nuovo Sconto",
    admin_min_days: "Giorni Minimi",
    admin_discount_percent: "Percentuale Sconto (%)",
    admin_discount_description: "Descrizione",
    admin_discount_added: "Sconto aggiunto",

    // Car-specific discounts
    admin_car_discounts_title: "Sconti per auto",
    admin_car_discounts_subtitle: "Seleziona un'auto e aggiungi fasce (min–max giorni) + sconto €/giorno.",
    admin_select_car: "Seleziona auto",
    admin_min_days: "Giorni min",
    admin_max_days: "Giorni max (opzionale)",
    admin_discount_per_day: "Sconto €/giorno",
    admin_no_car_discounts: "Nessuno sconto per questa auto.",
    admin_car_discount_overlap_note: "Se le fasce si sovrappongono, vince quella con min_days più alto (es. 3–5 batte 1–3 per il giorno 3).",
    admin_discount_deleted: "Sconto eliminato",
    admin_discount_failed: "Errore sconto",
    admin_discount_save_error: "Errore nel salvare lo sconto",
    admin_discount_delete_error: "Errore nell'eliminare lo sconto",
    admin_days_plus: "+ giorni",
    
    // Admin Messages
    admin_messages_title: "Messaggi Clienti",
    admin_messages_subtitle: "Messaggi inviati tramite il modulo di contatto",
    admin_messages_count: "messaggi",
    admin_no_messages: "Nessun messaggio ancora",
    admin_messages_appear: "I nuovi messaggi appariranno qui",
    admin_reply: "Rispondi",
    admin_delete_message_confirm: "Sei sicuro di voler eliminare questo messaggio?",
    admin_message_deleted: "Messaggio eliminato",
    admin_message_delete_error: "Errore nell'eliminare il messaggio",
    
    // Admin Payment
    admin_manage_payment: "Gestisci Pagamento",
    admin_client_label: "Cliente",
    admin_total_label: "Totale",
    admin_paid_so_far: "Pagato finora",
    admin_deposit_advance: "Caparra (Anticipo)",
    admin_deposit_amount: "Importo caparra",
    admin_register_deposit: "Registra Caparra",
    admin_mark_fully_paid: "Segna come Pagato Completamente",
    admin_remove_payment: "Rimuovi Pagamento",
    admin_paid_fully: "Segnato come pagato completamente!",
    admin_deposit_registered: "Caparra registrata!",
    admin_payment_removed: "Pagamento rimosso",
    admin_payment_error: "Errore nell'aggiornamento del pagamento",

    // Admin Booking Price Edit / Delete
    admin_edit_total: "Modifica Totale",
    admin_total_updated: "Totale aggiornato",
    admin_total_update_error: "Errore nell'aggiornamento del totale",
    admin_total_invalid: "Il totale deve essere maggiore di 0",
    admin_delete_booking: "Elimina Prenotazione",
    admin_delete_booking_confirm: "Sei sicuro di voler eliminare questa prenotazione?",
    admin_booking_deleted: "Prenotazione eliminata",
    admin_booking_delete_error: "Errore nell'eliminazione della prenotazione",
    admin_total_pending_note: "Consentito solo quando la prenotazione è in attesa.",

    // Min rental days
    min_days_error: "Questa auto richiede minimo",
    days: "giorni",
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'sq';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['sq'][key] || key;
  };

  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const languages = [
  { code: 'sq', name: 'Shqip', flag: '🇦🇱' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' }
];
